<template>
  <FinancialAnalyticsAccountMonthCard
    :inMonthRange.sync="showInMonthRange"
    :summaryData="summaryData"
    :mainData="mainData"
    :buildingsId="selectedHouseId"
    :title="`Финансовая информация по счету ${accountNumber} за  ${$options.filters.moment($parseDateFromString(month), 'MMMM YYYY')}`"
    :showRefunds="$can('rp.refunds', 'access', selectedHouseId)"
  />
</template>

<script>
import FinancialAnalyticsAccountMonthCard
  from "@/components/calculated-program/financial-analytics/FinancialAnalyticsAccountMonthCard";

export default {
  name:       "FinancialAnalyticsAccountMonth",
  components: {
    FinancialAnalyticsAccountMonthCard,
  },
  data:       () => ({
    accountFineInfo:     [],
    accountChargesInfo:  [],
    accountPaymentsInfo: [],
    showInMonthRange:    null,
    summaryData:         {},
    mainData:            {
      accountFineInfo:     [],
      accountChargesInfo:  [],
      accountPaymentsInfo: [],
      accountRefundsInfo:  [],
    },
  }),
  computed:   {
    accountNumber() {
      return this.$route.params.id;
    },
    month() {
      return this.$route.params.month;
    },
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

  },
  methods:    {
    getInfo() {
      const month = this.month;
      const buildingId = this.selectedHouseId;

      return Promise.all([
        this.$http.get('month_account_summary', {
          params: {
            account_number: this.accountNumber,
            month:          month,
            buildings_id:   buildingId,
            to_month:       this.showInMonthRange,
          },
        }).then(( { data } ) => {
          this.summaryData = data.summary;
          this.mainData.accountFineInfo = data.fines_data;
          this.mainData.accountChargesInfo = data.charges_data;
          this.mainData.accountPaymentsInfo = data.invoices_data;
        }),

        this.$can('rp.refunds', 'access', buildingId) && (
          this.$http.get('refund', {
            params: {
              buildings_id: buildingId,
              filters:      JSON.stringify([["account_number", "equals", this.accountNumber]]),
              from:         month,
              to:           month,
            },
          }).then(( { data } ) => {
            this.mainData.accountRefundsInfo = data.invoices;
          })
        ),
      ]);
    },
  },
  mounted() {
    this.showInMonthRange = localStorage['financial-analytics-account'] === 'true';
  },
  watch:      {
    accountNumber() {
      this.getInfo();
    },
    month() {
      this.getInfo();
    },
    showInMonthRange() {
      this.getInfo();
      localStorage['financial-analytics-account'] = this.showInMonthRange;
    },
  },
};
</script>

<style lang="scss">
.financial-analytics-account-month-summary-table {
  width: 100%;
  margin-bottom: 15px;
  border-collapse: collapse;

  th, td {
    padding: 5px;
  }

  th, td {
    width: 25%;
    text-align: center;
    border-left: 1px solid rgba(0, 0, 0, .1);
    border-right: 1px solid rgba(0, 0, 0, .1);
  }

  th {
    border-top: 1px solid rgba(0, 0, 0, .1);
  }

  td {
    border-bottom: 1px solid rgba(0, 0, 0, .1);
  }
}

.financial-analytics-tariffs-table {
  line-height: 1.2;


  thead {
    th {
      border: 1px solid rgba(0, 0, 0, .2);
      padding-top: 1rem !important;
      padding-bottom: 1rem !important;
    }
  }

  &__cell {
    padding: 5px 10px !important;
  }

  .vs-con-tbody {
    border: none;
  }

  &__group-row {
    background: #f2f2f2 !important;
    border-top: 1px solid rgba(0, 0, 0, .2);
    border-bottom: 1px solid rgba(0, 0, 0, .2);

    td {

      &:first-child {
        border-left: 1px solid rgba(0, 0, 0, .2);
      }

      &:last-child {
        border-right: 1px solid rgba(0, 0, 0, .2);
      }
    }

    .tariff-row__name {
      font-weight: 500;
      padding: 5px;

      &:not(.tariff-row__name--hidden) {
      }
    }
  }

  &__row {
    td {
      border: 1px solid rgba(0, 0, 0, .2) !important;
    }
  }

  tr {
    &:hover {
      transform: none !important;
    }
  }
}


.tariff-row {
  td {
    &:first-child {
      border-left: 1px solid rgba(0, 0, 0, .2);
    }

    &:last-child {
      border-right: 1px solid rgba(0, 0, 0, .2);
    }
  }


  &__name {
    padding: 0 10px 0;
    white-space: nowrap;

    &--hidden {
      opacity: 0;
    }

    &--center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    &--full {
      display: block;
      font-size: .85rem;
    }
  }

  &__formula {
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-all;
    white-space: nowrap;
    min-width: 400px;
    width: 30vw;
    position: relative;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 10px;
      background: #fff;
    }

    .tariff-formula {
      overflow: hidden;
      padding: 0 10px;
    }
  }

  &__unit-id {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    .con-select {
      max-width: 80px;

      .vs-select--input {
        padding: 5px 10px;
      }
    }
  }

  &__value {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__show-empty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__count-fine {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__extra-values {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
  }
}
</style>
